import {InputBase_v2} from './InputBase_v2'
import {ButtonSubmit} from './Buttons/ButtonSubmit'
import * as service from '~/api/requests'
import * as notification from '~/ToastGenerator'
import {createRequestView} from '~/legacy/request.edit/RequestList'
import adoptRequest from '~/legacy/request.edit/adapters/request'

const StatusSearchForm = {
	data: () => ({
		name: '',
		phone: '',
		serial: '',
		loading: false,
	}),
	methods: {
		checkRequest(event) {
			event.preventDefault()

			if (this.loading) return

			this.laoding = true

			if (this.name.length > 0) {
				service.getRequestByName(this.name)
					.then((response) => {
						if (!response.status) throw new Error(response.error)
						return response
					})
					.then(({data: request}) => createRequestView(adoptRequest(request)))
					.catch((error) => notification.error({
						heading: 'Ошибка',
						text: error.message,
						autohide: true,
						delay: 5000,
					}))
					.finally(() => this.loading = false)
			} else if (this.phone.length > 0) {
				service.getRequestByPhone(this.phone)
					.then((response) => {
						if (!response.status) throw new Error(response.error)
						return response
					})
					.then(({data: requests}) => createRequestView(adoptRequest(requests.shift())))
					.catch((error) => notification.error({
						heading: 'Ошибка',
						text: error.message,
						autohide: true,
						delay: 5000,
					}))
					.finally(() => this.loading = false)
			} else if (this.serial.length > 0) {
				service.getRequestBySerial(this.serial)
					.then((response) => {
						if (!response.status) throw new Error(response.error)
						return response
					})
					.then(({data: requests}) => createRequestView(adoptRequest(requests.shift())))
					.catch((error) => notification.error({
						heading: 'Ошибка',
						text: error.message,
						autohide: true,
						delay: 5000,
					}))
					.finally(() => this.loading = false)
			}
		},
	},
	render(h) {
		return (
			<form onSubmit={this.checkRequest}>
				<p>Заполните <b>одно</b> из полей для уточнения статуса заявки</p>
				<InputBase_v2
					label="Номер заявки"
					name="name"
					type="text"
					value={this.name}
					vOn:input={(value) => this.name = value}
				/>
				<br/>
				<InputBase_v2
					label="Ваш телефон"
					name="phone"
					type="tel"
					value={this.phone}
					vOn:input={(value) => this.phone = value}
				/>
				<br/>
				<InputBase_v2
					label="Серийный номер"
					name="serial"
					type="text"
					value={this.serial}
					vOn:input={(value) => this.serial = value}
				/>
				<ButtonSubmit
					class="mt-5"
					loading={this.loading}
				/>
			</form>
		)
	},
}

export default StatusSearchForm
